import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type {
  VrCaptureRequest,
  VrCaptureRequestPayload,
} from '@indutrust/factory-model';
import { EnvironmentService } from '@indutrust/shared-env';
import type { Observable } from 'rxjs';

/**
 * API client for assisted VR capture booking on a factory profile.
 *
 * Submits supplier requests for Indutrust-operated on-site panorama capture
 * via `POST /factories/{factoryId}/vr_capture_requests`.
 */
@Service()
export class VrCaptureRequestApiClient {
  private readonly envService = inject(EnvironmentService);
  private readonly http = inject(HttpClient);

  /**
   * Submits a capture booking request for the given factory.
   *
   * @param factoryId - Target factory id owned by the authenticated supplier.
   * @param payload - Optional scheduling notes and contact phone.
   * @returns An observable emitting the created {@link VrCaptureRequest}.
   */
  create(
    factoryId: number,
    payload: VrCaptureRequestPayload
  ): Observable<VrCaptureRequest> {
    return this.http.post<VrCaptureRequest>(
      `${this.baseUrl}/factories/${factoryId}/vr_capture_requests`,
      payload
    );
  }

  private get baseUrl(): string {
    return this.envService.getApiUrl();
  }
}
